// src/data/agreementData.js - the CODE over the agreement tables (ruling 321 slice 3c, task list section 735).
// The tables - sub-yards, abolished positions, agreement rules, agreements, reference guides, the agreement lookup, shared
// agreements and withdrawn committees - are installation content: installations\smart-td\content\agreementTables.js,
// projected to src\data\agreementTables.js. Everything they export is re-exported here, so no importer changed.
import { AGREEMENTS, SHARED_AGREEMENTS, TERRITORY_LOCATIONS } from './agreementTables';
export * from './agreementTables';

// ── LOCATIONS BY RAILROAD ─────────────────────────────────────────────────────
const _fw=(p)=>{const o={};for(const [k,v] of p)if(!(k in o))o[k]=v;return o;}; export const LOCATIONS_BY_RAILROAD = _fw(
  AGREEMENTS
    .filter(a => a.railroadKey && a.locations.length > 0)
    .flatMap(a => { const S="\u241F"; const e=[]; if (a.craft) e.push([a.craft + S + a.railroadKey, a.locations]); e.push([a.railroadKey, a.locations]); return e; })
    // Section 807: home terminals for railroads whose agreements are not yet on file (the T&E pack). An agreement's own list wins.
    .concat(Object.entries(TERRITORY_LOCATIONS || {}))
);

// === CRAFT VOCABULARY — single source of truth ===
// Moved from NewClaim.js so QuickFile.js reads the same data. Craft -> railroad -> GC -> agreement.
// RAILROADS and COMMITTEE_LOOKUP live in ./committeeData.js (moved 2026-09-22, section 341) so the
// functions/ side can share them. Re-exported here so no importer changes.
export { RAILROADS, COMMITTEE_LOOKUP } from './committeeData';

// For an agreement id: the other committees that custody the same instrument, or null.
export function sharedAgreementFor(agreementId) {
  const s = SHARED_AGREEMENTS.find(x => x.agreementIds.includes(agreementId));
  if (!s) return null;
  const mine = s.custodians[agreementId];
  const others = s.agreementIds.filter(i => i !== agreementId).map(i => s.custodians[i]);
  return { instrument: s.instrument, kind: s.kind, custodian: mine, sharedWith: others, party: s.party || null, confirmed: s.confirmed };
}
